import { useState } from 'react'
import BookingFilters from '../bookings/BookingFilters'
import BookingsTable from '../bookings/BookingsTable'
import { useGetBookingsQuery } from '../../store/api/services'

const STATUSES = ['All', 'pending', 'confirmed', 'in_progress', 'completed', 'cancelled']

export default function Bookings() {
  const [filter, setFilter] = useState('All')

  const { data: bookings = [], isLoading, isError } = useGetBookingsQuery()

  const rows = filter === 'All'
    ? bookings
    : bookings.filter(b => b.status === filter)

  return (
    <div>
      {/* Page Header */}
      <div className="page-header">
        <div>
          <h2 className="page-title">Bookings</h2>
          <p className="page-subtitle">{bookings.length} total bookings</p>
        </div>
      </div>

      <BookingFilters active={filter} onChange={setFilter} statuses={STATUSES} />

      <div className="panel">
        {isLoading && (
          <p style={{ color: 'var(--text-muted)', padding: '24px 0', fontFamily: "'Barlow',sans-serif" }}>
            Loading bookings...
          </p>
        )}
        {isError && (
          <p style={{ color: '#F87171', padding: '24px 0', fontFamily: "'Barlow',sans-serif" }}>
            Failed to load bookings.
          </p>
        )}
        {!isLoading && !isError && <BookingsTable rows={rows} />}
      </div>
    </div>
  )
}
